import React, { useEffect, useState } from "react"
import classes from './AverageSubmissionsChart.module.css'
import { useSelector } from 'react-redux';

const AverageSubmissionsChart = ({ avergeScore, avergeClass, generalAverageText }) => {
    const [myGradeSubmission, setMyGradeSubmission] = useState()
    const [classGradeSubmission, setClassGradeSubmission] = useState()
    const [classSqurePosition, setClassSqurePosition] = useState()
    const [classSqureLeftPosition, setClassSqureLeftPosition] = useState()
    const texts = useSelector(state => state.translate.texts);

    useEffect(() => {
        setMyGradeSubmission(getSubbmissinScorePosition(avergeScore))
    }, [avergeScore])

    useEffect(() => {
        setClassGradeSubmission(getSubmmisionClaseGredeRotation(avergeClass))
        getAvergeClassSqurePosition(avergeClass)
    }, [avergeClass])

    function getSubbmissinScorePosition(avergeScore) {
        if (avergeScore || avergeScore === 0) {
            let initialScore = 0
            let startingPoint = -132.35
            let stepsSize = 265
            let numSteps = 100
            let temp = avergeScore - initialScore
            let temp2 = temp * (stepsSize / numSteps)
            return (startingPoint) + temp2

        }

    }

    function getSubmmisionClaseGredeRotation(avergeScore) {
        if (avergeScore || avergeScore === 0) {
            let initialScore = 0
            let startingPoint = -120.35
            let stepsSize = 248
            let numSteps = 100
            let temp = avergeScore - initialScore
            let temp2 = temp * (stepsSize / numSteps)
            return (startingPoint) + temp2

        }

    }
    function getAvergeClassSqurePosition(avergeClass) {
        if (avergeClass || avergeClass === 0) {
            if (avergeClass >15) {
                let topMark = avergeClass >= 50 ? 100 - avergeClass : 50 - avergeClass
                let startPoint = avergeClass >= 50 ? 80 : 0
                let numSteps = avergeClass >= 50 ? 35 : 15
                let height = avergeClass >= 50 ? 80 : 40
                let temp = topMark * (height / numSteps)
                setClassSqurePosition(avergeClass >= 50 ? startPoint - temp : startPoint + temp)
            }
            else {
                setClassSqurePosition(70)
            }

            let leftPosition = avergeClass >= 50 ? 70 : -140
            setClassSqureLeftPosition(leftPosition)
        }


    }
    return (
        <div>
            <div className={classes.SpeedOMeterChart}>
                <div className={classes.SpeedOMeter}></div>
                {myGradeSubmission && <div className={classes.SpeedOMeterPointer} style={{ transform: `rotate( ${myGradeSubmission}deg )` }}></div>}
                <div className={classes.Circle}></div>
                <div className={classes.CircleIn}></div>
                {classGradeSubmission && avergeClass >= 0 && <div className={classes.SpeedOMeterPointerClassSub} style={{ transform: `rotate(calc( ${classGradeSubmission}deg))` }}>
                    <div className={classes.TryAngle}></div>
                </div>}
                {/* {classSqurePosition && avergeClass >= 0 && <div className={classes.AvergeClassSqure} style={{ top: `${classSqurePosition}px`, insetInlineEnd: `${classSqureLeftPosition}px` }}>
                    <div className={classes.AvergeClass}>{Math.round(avergeClass * 10) / 10}</div>
                    <div className={classes.GeneralAverageTxt}>{generalAverageText ? generalAverageText : texts.generalAverage}</div>
                </div>} */}
            </div>
        </div>
    )
}
export default AverageSubmissionsChart